import { useLayoutEffect } from "react";
import { siteUrl } from "@/lib/site";

const DEFAULT_TITLE = "دليل المسافر للحجوزات | Travelers Guide";
const DEFAULT_DESCRIPTION = "دليل المسافر للحجوزات — وكالة سفر في منطقة السيف بمملكة البحرين. تواصلوا معنا للاستفسار عن رحلتكم وترتيب الحجوزات.";
const DEFAULT_URL = siteUrl("/");

const setMeta = (selector, attrs) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    const match = selector.match(/\[(name|property)="(.+?)"\]/);
    if (match) el.setAttribute(match[1], match[2]);
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([key, value]) => el.setAttribute(key, value));
};

// عنوان صفحة بحد أقصى 60 حرفًا: يبقي الاسم والعلامة، ويُسقط المقطع الأوسط عند الحاجة فقط.
// لا يغيّر الروابط ولا العناوين المرئية داخل الصفحات — وسم <title> فقط.
export const pageTitle = (name, section) => {
  const full = `${name} — ${section} | دليل المسافر`;
  if (full.length <= 60) return full;
  const short = `${name} | دليل المسافر`;
  return short.length <= 60 ? short : name;
};

export const usePageMeta = (title, canonical, description = DEFAULT_DESCRIPTION, noindex = false, ogImage = "") => {
  useLayoutEffect(() => {
    document.title = title;
    setMeta('meta[name="description"]', { content: description });
    setMeta('meta[name="robots"]', { content: noindex ? "noindex, nofollow" : "index, follow" });
    setMeta('meta[property="og:title"]', { content: title });
    setMeta('meta[property="og:description"]', { content: description });
    setMeta('meta[property="og:url"]', { content: canonical });
    if (ogImage) {
      setMeta('meta[property="og:image"]', { content: ogImage });
      setMeta('meta[name="twitter:card"]', { content: "summary_large_image" });
      setMeta('meta[name="twitter:image"]', { content: ogImage });
    }
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonical);

    return () => {
      document.title = DEFAULT_TITLE;
      setMeta('meta[name="description"]', { content: DEFAULT_DESCRIPTION });
      setMeta('meta[name="robots"]', { content: "index, follow" });
      setMeta('meta[property="og:title"]', { content: DEFAULT_TITLE });
      setMeta('meta[property="og:description"]', { content: DEFAULT_DESCRIPTION });
      setMeta('meta[property="og:url"]', { content: DEFAULT_URL });
      setMeta('meta[property="og:image"]', { content: siteUrl("/og/brand-card.png") });
      link.setAttribute("href", DEFAULT_URL);
    };
  }, [title, canonical, description, noindex, ogImage]);
};
